import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const Check = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{
				width: "100%",
				height: "100%",
			}}
			viewBox="0 0 15.252 11.257">
			<path
				id="Path_193"
				data-name="Path 193"
				d="M-19078.512,1176.185l3.994,3.993,7.016-7.014"
				transform="translate(19080.633 -1171.043)"
				fill="none"
				style={{ stroke: "currentcolor" }}
				strokeLinecap="round"
				strokeWidth="3"
			/>
		</svg>
	</i>
);

Check.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
Check.defaultProps = {
	className: "",
	style: {},
};

export default Check;
export { Check };
